module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/hipercard-e79080a05f2c926173b536717cb22641.svg";